import React, { useContext } from 'react';

import TextButton from '../../../TextButton';
import { ToastContext } from '../../../Toast/ToastContext';
import { ToastLinkProps } from './ToastLink.types';

const ToastLink = ({
  dataHook,
  href,
  target,
  onClick,
  children,
}: ToastLinkProps) => {
  const toastHidden = useContext(ToastContext)?.hidden ?? false;

  return (
    <TextButton
      dataHook={dataHook}
      as="a"
      skin="light"
      size="medium"
      underline="always"
      href={href}
      target={target}
      onClick={onClick}
      disabled={toastHidden}
    >
      {children}
    </TextButton>
  );
};

export default ToastLink;
